import { env } from '@/config/env'

export type AnalyticsEnvironment = 'local' | 'dev' | 'qa' | 'staging' | 'prod'

/** Deployment tag for PostHog super-properties (rule 56). */
export function resolveAnalyticsEnvironment(): AnalyticsEnvironment {
  return env.VITE_APP_ENV
}
